// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"238":"checkoutPage","818":"materialLayout"}[chunkId] + "." + {"238":"b9c1ba37","818":"71bf631b"}[chunkId] + ".js";
};